import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_membership_points_ctrl_acc_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  card_no: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  option: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  next_expiry_date_check: fromDatatype.TimestampTzDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  report_type: fromDatatype.VarcharDatatypeInterface;
  report_code: fromDatatype.VarcharDatatypeInterface;
  report_option: fromDatatype.TextDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  point_currency: fromDatatype.VarcharDatatypeInterface;
  net_amount: fromDatatype.NumericDatatypeInterface;
  balance_amount: fromDatatype.NumericDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_crm_membership_points_ctrl_acc_RowClass implements bl_crm_membership_points_ctrl_acc_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  card_no: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  option: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  next_expiry_date_check: fromDatatype.TimestampTzDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  report_type: fromDatatype.VarcharDatatypeInterface;
  report_code: fromDatatype.VarcharDatatypeInterface;
  report_option: fromDatatype.TextDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  point_currency: fromDatatype.VarcharDatatypeInterface;
  net_amount: fromDatatype.NumericDatatypeInterface;
  balance_amount: fromDatatype.NumericDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}


